import { Options } from '@splidejs/react-splide';
import { Children, ReactNode } from 'react';
import CarrouselElements from './components/elements';

type CarrouselProps = {
  children: ReactNode;
  options?: Options;
  ariaLabel?: string;
  className?: string;
  hideArrows?: boolean;
  onChange?: (index: number) => void;
};

const Carrousel = ({ children, options, ariaLabel, className, hideArrows = false, onChange }: CarrouselProps) => (
  <CarrouselElements.Root aria-label={ariaLabel} className={className} onChange={onChange} options={options}>
    <CarrouselElements.Body>
      {!hideArrows && <CarrouselElements.Arrow arrowDirection="prev" />}
      <CarrouselElements.Content>
        {Children.map(children, (child, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <CarrouselElements.Slide key={`${index}slide`}>{child}</CarrouselElements.Slide>
        ))}
      </CarrouselElements.Content>
      {!hideArrows && <CarrouselElements.Arrow arrowDirection="next" />}
    </CarrouselElements.Body>
    <CarrouselElements.Pagination />
  </CarrouselElements.Root>
);

export default Carrousel;
